const columnIdDelimiter = '_';
const generateColumnId = (reportId, field) => `${reportId}${columnIdDelimiter}${field}`;

export default generateColumnId;
export { columnIdDelimiter };
